module.exports = __webpack_public_path__ + "static/media/ZTI.aa307fda.pdf";